import FilterTile from "./FilterTile";
import type { FilterType } from "./filterTypes";

//TODO: Check if these types DRY "this is almost the same as ActiveFiltersListProps. Can we get a central place with these and avoid repetition?"

type AvailableFiltersListProps = {
  availableFilterKeys: string[];
  activeFilter: string | null;
  availableFilters: Record<string, { data_type: FilterType }>;
  onFilterClick: (filterKey: string) => void;
  visibleColumns?: string[];
  hiddenColumns?: string[];
  columnsTitleCreator?: (column: string) => string;
};

export default function AvailableFiltersList({
  availableFilterKeys,
  activeFilter,
  availableFilters,
  onFilterClick,
  visibleColumns = [],
  hiddenColumns = [],
  columnsTitleCreator,
}: AvailableFiltersListProps) {
  if (!availableFilterKeys.length) return null;

  const visibleInTable = availableFilterKeys.filter((filter) =>
    visibleColumns.includes(filter),
  );

  const hiddenInTable = availableFilterKeys.filter((filter) =>
    hiddenColumns.includes(filter),
  );

  // Filterable fields that don't map to a visible or hidden table column (e.g.
  // filter-only dimensions the backend serves without a corresponding column)
  // must still be offered — otherwise the filter panel exposes fewer fields
  // than exist and those filters become unreachable.
  const otherFilters = availableFilterKeys.filter(
    (filter) =>
      !visibleColumns.includes(filter) && !hiddenColumns.includes(filter),
  );

  return (
    <>
      {visibleInTable.length > 0 && (
        <div className="mb-4">
          <h2 className="text-xs font-bold mb-2">
            <span>
              SHOWN IN TABLE{" "}
              <span className="text-gray-500">({visibleInTable.length})</span>
            </span>
          </h2>
          <div className="flex flex-col gap-2">
            {visibleInTable.map((filter) => (
              <FilterTile
                key={filter}
                filter={filter}
                isSelected={activeFilter === filter}
                dataType={availableFilters[filter].data_type}
                hasFilterValues={false}
                onClick={() => onFilterClick(filter)}
                showGlowEffect={true}
                columnsTitleCreator={columnsTitleCreator}
              />
            ))}
          </div>
        </div>
      )}

      {hiddenInTable.length > 0 && (
        <div className="mb-4">
          <h2 className="text-xs font-bold mb-2">
            <span>
              HIDDEN IN TABLE{" "}
              <span className="text-gray-500">({hiddenInTable.length})</span>
            </span>
          </h2>
          <div className="flex flex-col gap-2">
            {hiddenInTable.map((filter) => (
              <FilterTile
                key={filter}
                filter={filter}
                isSelected={activeFilter === filter}
                dataType={availableFilters[filter].data_type}
                hasFilterValues={false}
                onClick={() => onFilterClick(filter)}
                showGlowEffect={true}
                columnsTitleCreator={columnsTitleCreator}
              />
            ))}
          </div>
        </div>
      )}

      {otherFilters.length > 0 && (
        <div className="mb-4">
          <h2 className="text-xs font-bold mb-2">
            <span>
              MORE FILTERS{" "}
              <span className="text-gray-500">({otherFilters.length})</span>
            </span>
          </h2>
          <div className="flex flex-col gap-2">
            {otherFilters.map((filter) => (
              <FilterTile
                key={filter}
                filter={filter}
                isSelected={activeFilter === filter}
                dataType={availableFilters[filter].data_type}
                hasFilterValues={false}
                onClick={() => onFilterClick(filter)}
                showGlowEffect={true}
                columnsTitleCreator={columnsTitleCreator}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
}
